import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-flex-container",
  templateUrl: "./flex-container.component.html",
  styleUrls: ["./flex-container.component.scss"]
})
export class FlexContainerComponent {
  @Input() title: string = "";
  @Input() titleBelow: string = "";
  @Input() value: string = "";
  @Input() type: OrderType = null;
  @Input() currency: boolean = false;
  @Input() memberDiscount: boolean = false;

  @Input() drivePlusMembership: string = "";

  constructor(public translate: TranslateService) {}
}

type OrderType =
  | "normal"
  | "total"
  | "discount"
  | "included"
  | "zeroInstalment"
  | "bnplSubsidized";